import React, { CSSProperties, FC, RefObject, useRef } from "react"
import Styles from "../styles/SelectBox.module.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useClickAway } from "../hooks/useClickAway"
import { CloseIcon } from "../icons/CloseIcon";

type Props = {
    visible:boolean,
    closeModal:()=>void,
    children:JSX.Element,
    closeModalIconVisible?:boolean,
    style?:CSSProperties,
    scrollContentRef:RefObject<HTMLDivElement>
}

export const SelectBox: FC<Props> = ( {
    visible,
    closeModal,
    children,
    closeModalIconVisible = true,
    style,
    scrollContentRef
} ) => {
    
    const containerRef = useRef<HTMLDivElement>(null)
    useClickAway( {
        clickExceptRef: containerRef,
        clickAwayFunction: () => closeModal()
    })

    return (
        <div
            ref={ containerRef }
            className={ Styles.container }
            style={ { display: visible ? "flex" : "none", ...style } }>
            <div
                className={ Styles.modal_content }
                ref={ scrollContentRef }>
                <div
                    className={ Styles.icon_container }
                    style={ closeModalIconVisible ? {} : { display: "none" } }>
                    <CloseIcon
                        className={ Styles.icon }
                        onClick={ () => closeModal() } />
                </div>
                { children }
            </div>
        </div> )
}
